export default __webpack_public_path__ + "static/media/minus_white.cf410577.svg";